import React, {useContext} from "react";
import styled from "styled-components";
// @ts-ignore
import classNames from 'classnames';

import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import {useTranslation} from "react-i18next";

const Wrapper = styled.div`
  border-top-width: 4px;
  border-top-style: solid;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 2.875rem;
  padding-top: 0.75em;
  width: fit-content;
`;

const Item = styled.div`
  font-family: Mapfre-Light;

  &.is-selected {
    font-family: Mapfre-Black;
  }
`;

const Separator = styled.div`
  margin: 0 1em;
  border-left-width: 3px;
  border-left-style: solid;
`;

interface Props {
    isLife: boolean,
    setIsLife: React.Dispatch<React.SetStateAction<boolean>>,
}

const LifeSelector = ({isLife, setIsLife}: Props) => {
    const {t} = useTranslation();

    return (
        <Wrapper>
            <Item
                className={classNames({'is-selected': isLife})}
                onClick={() => setIsLife(true)}
            >
                { t('lifeSelector.life') }
            </Item>
            <Separator/>
            <Item
                className={classNames({'is-selected': !isLife})}
                onClick={() => setIsLife(false)}
            >
                { t('lifeSelector.noLife') }
            </Item>
        </Wrapper>
    );
};

export default LifeSelector;
